<template>
    <div>
        <div
            v-show="completions.length"
            ref="inner"
            class="l-ss-c-completions-inner">
            <p
                v-show="showEmptySkuOfferTitle"
                class="l-ss-c-completions-title">
                {{ $t('completions.interestTitle') }}
            </p>
            <taps
                v-if="showTaps"
                :query="query"
                :data="tapsComplitions"
                is-taps-complitions
                :count="tapsCount"
                @handle-tags-click="(value) => $emit('handleTagsClick', value)"
                @preview-tab-click="(value) => $emit('preview-tab-click', value)"/>
            <div
                v-for="(group, key , groupIndex) in groups"
                :key="groupIndex"
                :class="{
                    [`l-ss-c-completions-group-${key}`]: ($configuration.completionsFullWidth && key === 'offers'),
                    'l-ss-c-completions-group-extra-offers': key === 'extra_offer',
                }"
                class="l-ss-c-completions-group"
                @click="handleClick"
                @contextmenu="handleClick($event, 'contextmenu')">
                <h2
                    v-if="key === 'extra_offer'"
                    class="l-ss-c-completions-group-title">
                    {{ $t('results.extraOffersTitle') }}
                </h2>
                <h3
                    v-if="key !== 'extra_offer' && key !== 'offers' && $configuration.completionsTitles"
                    class="l-ss-c-completions-item-label">
                    {{ $t(`completions.category.${key}`) }}
                </h3>
                <completions-item
                    v-show="isItemVisible(item)"
                    v-for="(item, itemIndex) in group"
                    :key="item._id"
                    :data="item"
                    :data-id="item._id"
                    :data-position="itemIndex + 1"
                    :is-active="itemIndex === activeIndex"
                    :is-cart-available="$configuration.features.addToCartButton"
                    :is-cat-prefix-active="$configuration.features.catPrefix"
                    @add-to-cart="offer => $emit('add-to-cart', offer)"
                    @remove-history="hint => $emit('remove-history', hint)"/>
            </div>
        </div>

        <div
            v-if="isVisibleShowAllButton"
            class="l-ss-c-completions-bar">
            <button
                class="l-ss-c-completions-show-all"
                @click="searchAll">
                <span>
                    {{ $t('completions.showAll') }}
                </span>
            </button>
        </div>
        <div
            v-show="$configuration.skuStrict && completions.length === 0"
            class="l-ss-c-completions-sku">
            <p class="l-ss-c-completions-sku-empty-title">{{ $t('completions.emptyResultsBySku') }}</p>
            <button
                class="l-ss-c-button l-ss-c-button-large"
                @click="handleEmptyResetClick">
                {{ $t('categories.emptyListButtonResetQuery') }}
            </button>
        </div>
    </div>
</template>

<script>
    import CompletionsItem from './completions-item';
    import Taps from '@/core/components/taps.vue';

    export default {
        components: {
            Taps,
            CompletionsItem,
        },
        props: {
            completions: {
                type: Array,
                default: () => ([]),
            },
            tapsComplitions: {
                type: Array,
                default: () => ([]),
            },
            showAllVisible: {
                type: Boolean,
                default: true,
            },
            query: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                activeIndex: null,
                dataSet: {},
                completionTarget: {},
            };
        },
        computed: {
            taps() {
                return {
                    desktop: (this.$configuration.completions?.taps?.desktop) ? this.$configuration.completions?.taps?.desktop : {},
                    mobile: (this.$configuration.completions?.taps?.mobile) ? this.$configuration.completions?.taps?.mobile : {},
                };
            },
            showTaps() {
                return (this.$screen.isMobile && this.taps.mobile.active) || ( !this.$screen.isMobile && this.taps.desktop.active);
            },
            tapsCount() {
                return (this.$screen.isMobile) ? this.taps.mobile.count : this.taps.desktop.count;
            },
            groups() {
                let groups = {};
                this.completions.forEach(completion => {
                    if (!groups[completion.label]) {
                        groups[completion.label] = [];
                    }
                    groups[completion.label].push(completion);
                });

                return groups;
            },
            allCompletionsHidden() {
                return this.completions.some(item => item.visible === true) === false;
            },
            showEmptySkuOfferTitle() {
                return this.skuStrict && this.allCompletionsHidden && this.isSku && this.completions.length > 0;
            },
            skuStrict() {
                return this.$configuration.skuStrict;
            },
            isSku() {
                return Boolean((this.query || '').match(this.$configuration.skuRegExp));
            },
            isVisibleShowAllButton() {
                return this.showAllVisible && this.completions.length > 0 && this.query?.trim();
            },
        },

        watch: {
            completions: {
                handler() {
                    this.$refs.inner.scrollTo(0, 0);
                },
            },
        },
        methods: {
            handleTagsClick(tag) {
                this.$emit('handleTagsClick', this.factoryQuery(this.query, tag));
            },
            isItemVisible(item) {
                return item.visible || this.allCompletionsHidden && this.skuStrict;
            },
            handleEmptyResetClick(event) {
                event.preventDefault();
                event.stopPropagation();
                this.$emit('reset-query');
            },
            handleClick(event, customEventType = null) {
                event.stopPropagation();
                if (this.completionTarget) {
                    const path = event.path || (event.composedPath && event.composedPath());
                    const completionTarget = path.find(element => element.dataset && element.dataset?.id);
                    if (completionTarget) {
                        const dataSet = completionTarget.dataset;
                        if (completionTarget) {
                            const completion = this.completions.find(item => item._id && item._id === dataSet.id);
                            this.$emit('click', {
                                event: event,
                                completion: completion,
                                position: dataSet.position,
                                customEventType,
                            });
                        }
                    }
                }
            },

            searchAll(event) {
                this.$emit('search-all');

                this.$emit('preview-show-all-click', { type: 'previewShowAllClick', event });
            },
        },
    };
</script>
